<script setup>
const handleClick = (type) => {
  if (type === 'bitcoin') {
    window.open('https://utxoverse.xyz/bitcoin', '_blank')
  } else if (type === 'xsat') {
    window.open('https://utxoverse.xyz/xsat', '_blank')
  } else if (type === 'become') {
    window.open('https://docs.exsat.network/guides-of-data-consensus/run-a-btc-validator', '_blank')
  } else if (type === 'esBTC') {
    window.open('https://esbtc.exsat.network/', '_blank')
  }
}
const handleLearnMore = () => {
  window.open('https://docs.exsat.network/guides-of-data-consensus/run-a-btc-validator', '_blank')
}
</script>
<template>
  <svg
    width="980"
    height="230"
    viewBox="0 0 980 230"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="48"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="0" y="48.4545">How does</tspan>
      <tspan x="446.047" y="48.4545">Work</tspan>
    </text>
    <text
      fill="url(#paint0_linear_1691_436)"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="48"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="233.234" y="48.4545">Validator</tspan>
    </text>
    <text
      fill="#8C8C8C"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="16"
      letter-spacing="0.01em"
      text-decoration="underline"
      @click="handleLearnMore"
    >
      <tspan x="555.013" y="143.818">Learn more</tspan>
    </text>
    <text
      fill="#8C8C8C"
      xml:space="default"
      font-family="Inter"
      font-size="16"
      letter-spacing="0.01em"
    >
      <tspan x="0" y="95.8182">
        In exSat, there are two groups of validators (BTC validators and XSAT validators) who are
        responsible for reaching consensus
      </tspan>
      <tspan x="0" y="119.818">
        on the BTC block hashes to make sure the synced BTC block data is correct. There is an
        incentive mechanism to these
      </tspan>
      <tspan x="0" y="143.818">
        validators as well, which encourage them to reach consensus promptly.
      </tspan>
    </text>
    <path
      style="cursor: pointer"
      d="M0 194C0 187.373 5.37258 182 12 182H297C303.627 182 309 187.373 309 194V218C309 224.627 303.627 230 297 230H12C5.37258 230 0 224.627 0 218V194Z"
      fill="#111111"
      @click="handleClick('bitcoin')"
    />
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="16"
      font-weight="600"
      letter-spacing="0.01em"
      @click="handleClick('bitcoin')"
    >
      <tspan x="12" y="211.818">Explorer BTC Validators &#38; Stake</tspan>
    </text>
    <path
      style="cursor: pointer"
      d="M275 212L287 200M287 200H279M287 200V208"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('bitcoin')"
    />
    <path
      d="M325 194C325 187.373 330.373 182 337 182H568C574.627 182 580 187.373 580 194V218C580 224.627 574.627 230 568 230H337C330.373 230 325 224.627 325 218V194Z"
      fill="#111111"
      style="cursor: pointer"
      @click="handleClick('xsat')"
    />
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="16"
      font-weight="600"
      letter-spacing="0.01em"
      @click="handleClick('xsat')"
    >
      <tspan x="337" y="211.818">Explorer XSAT Validators</tspan>
    </text>
    <path
      style="cursor: pointer"
      d="M546 212L558 200M558 200H550M558 200V208"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('xsat')"
    />
    <path
      style="cursor: pointer"
      d="M596 194C596 187.373 601.373 182 608 182H793C799.627 182 805 187.373 805 194V218C805 224.627 799.627 230 793 230H608C601.373 230 596 224.627 596 218V194Z"
      fill="#111111"
      @click="handleClick('become')"
    />
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="16"
      font-weight="600"
      letter-spacing="0.01em"
      @click="handleClick('become')"
    >
      <tspan x="608" y="211.818">Become a validator</tspan>
    </text>
    <path
      style="cursor: pointer"
      d="M771 212L783 200M783 200H775M783 200V208"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('become')"
    />
    <path
      d="M821 194C821 187.373 826.373 182 833 182H968C974.627 182 980 187.373 980 194V218C980 224.627 974.627 230 968 230H833C826.373 230 821 224.627 821 218V194Z"
      fill="#111111"
      style="cursor: pointer"
      @click="handleClick('esBTC')"
    />
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="16"
      font-weight="600"
      letter-spacing="0.01em"
      @click="handleClick('esBTC')"
    >
      <tspan x="833" y="211.818">Access esBTC</tspan>
    </text>
    <path
      style="cursor: pointer"
      d="M946 212L958 200M958 200H950M958 200V208"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('esBTC')"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1691_436"
        x1="306.491"
        y1="1.02737e-06"
        x2="331.11"
        y2="75.5307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.505" stop-color="#FF9900" />
        <stop offset="1" stop-color="#FF6B00" />
      </linearGradient>
    </defs>
  </svg>
</template>
